import classNames from 'classnames';
import React from 'react';

import {AboveTheFoldProvider} from '@udemy/design-system-utils';
import {CourseDirectoryContextProvider} from '@udemy/react-discovery-units';
import {ResourceContextMenuProvider} from '@udemy/resource-context-menu';

import {Banner} from './banner/banner.react-component';
import {CourseList} from './course-list/course-list';
import {useRolePlayCourseDirectory} from './hooks/use-role-play-course-directory';

export const RolePlayLandingPage: React.FC = () => {
    const {hasOrganization, isPersonalPlanSubscriber, ...courseDirectoryProps} =
        useRolePlayCourseDirectory();

    const ResourceContextMenuWrapper = ({children}: React.PropsWithChildren<unknown>) => {
        if (hasOrganization) {
            return <ResourceContextMenuProvider>{children}</ResourceContextMenuProvider>;
        }

        return <>{children}</>;
    };

    return (
        <>
            <AboveTheFoldProvider>
                <section
                    aria-labelledby="role-play-landing-page-heading"
                    className={classNames('ud-full-viewport-container')}
                >
                    <Banner />
                </section>
            </AboveTheFoldProvider>
            <CourseDirectoryContextProvider
                isPersonalPlanSubscriber={isPersonalPlanSubscriber}
                {...courseDirectoryProps}
            >
                <section
                    aria-labelledby="role-play-landing-page-body"
                    className={classNames('ud-full-viewport-container')}
                >
                    <div className={classNames('ud-container')}>
                        <ResourceContextMenuWrapper>
                            <CourseList
                                hasOrganization={hasOrganization}
                                isPersonalPlanSubscriber={isPersonalPlanSubscriber}
                            />
                        </ResourceContextMenuWrapper>
                    </div>
                </section>
            </CourseDirectoryContextProvider>
        </>
    );
};
